/**
 * 런처(그리드 시작점, Start) 설정 — global.tsv SSoT (architecture-review §5 P3 도메인 자기 파일).
 *
 * 그리드 밖 시작점을 구슬 파츠(piece)처럼 **모양 파이프**로 렌더하고, 런처 고유 효과
 * (단발 + 기본 치명타 확률)를 전투(critChance)와 정보팝업(stats)에 단일 출처로 공급한다.
 * "단발"은 effect DSL에 countMul이 없어 count=1이 자연 유지됨(추가 코드 0).
 *
 * 모양/효과 커스터마이즈 UI는 추후 환생포인트 작업 — 그때 SaveData에서 읽어 이 기본값을
 * override하는 getter 1곳만 추가하면 분기 신설 없이 얹힌다(현재 SaveData 무변경).
 */
import { evaluateFormula } from "@yjsgames/formula-evaluator";
import { globalRepo as r, K } from "../globalRepo.js";
import { parseModuleEffect, type ModuleEffectData } from "../../modules/ModuleEffect.js";
import type { FootprintId } from "../moduleFootprints.js";

const launcherEffect: ModuleEffectData = parseModuleEffect(r.getString(K.launcherEffect));

export const LAUNCHER: {
  /** 시작점 모양(SHAPE_CATALOG id) — 현재 시각 전용(물 흐름은 pathPortsAt(Start)=["right"] 고정). */
  readonly shapeId: string;
  readonly footprintId: FootprintId;
  /** 런처 고유 효과 mini-DSL 파싱 결과 — 정보팝업 stats(evaluateModuleEffectStats) 공용. */
  readonly effect: ModuleEffectData;
  /** 런처 기본 치명타 확률(레벨1 평가, 0~1 clamp) — CombatSystem.composeCritChance 합류용. critChance 미기재면 0. */
  readonly baseCritChance: number;
} = {
  shapeId: r.getString(K.launcherShapeId),
  footprintId: "single",
  effect: launcherEffect,
  baseCritChance: launcherEffect.critChance
    ? Math.max(0, Math.min(1, evaluateFormula(launcherEffect.critChance, { level: 1 })))
    : 0,
};
